/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-var-requires */
import * as React from 'react';
import { BillingLayoutComponent } from '@applications/billing/components/billing-layout';
import TextStyle from '@able/react/dist/TextStyle';
import { useNavigate } from 'react-router-dom';
import MessageTemplate from 'ted-ui/build/MessageTemplate';
import Grid from '@able/react/dist/Grid';
const ddErrorPage = require('../../../../../../images/DirectDebitErrorPage.svg');
const iconDevelopmentURL = require('../../../../../../images/able/able-sprites.svg');

export const ErrorPageDirectDebit = () => {
    const navigate = useNavigate();

    const goBacktoPreviousPage = () => {
        navigate(-1);
    }

    const onSubmitEnquiryClick = (e) => {
        e.preventDefault();
        navigate(`/app/customer-support/new-enquiry?category=Billing`);
    }

    return (
        <BillingLayoutComponent>
            <Grid padding={false}>
                <MessageTemplate
                    content={
                        <TextStyle element="p">
                            Go back to try submitting your request again or submit a support enquiry.
                        </TextStyle>
                    }
                    imageSrc={ddErrorPage}
                    primaryButton={{
                        element: 'button',
                        label: 'Submit enquiry',
                        variant: 'HighEmphasis',
                        events: {onClick: onSubmitEnquiryClick}
                    }}
                    secondaryButton={{
                        element: 'button',
                        label: 'Go back',
                        variant: 'LowEmphasis',
                        developmentUrl: iconDevelopmentURL,
                        icon: 'ChevronLeft',
                        events: {onClick: goBacktoPreviousPage}
                    }}
                    title="Request failed"
                    titleHeadingOrder={1} />
            </Grid>
        </BillingLayoutComponent>
    )
}
